<template>
  <div class="width-100 min-height padding-3 flex-column align-items-center justify-content-start" style="background: #f7f7f7">
    <div
      class="width-100 flex-column align-items-center bg-white br-reg justify-content-center padding-3 margin-bs"
      v-if="itemDetail.consignee || itemDetail.address"
    >
      <div class="width-100 flex-row align-items-center justify-content-start">
        <div class="fs-big fm-sh-bold" v-if="itemDetail.consignee">{{ itemDetail.consignee }}</div>
        <div class="fs-mid-sml darkgrey" v-if="itemDetail.consignee_phone">{{ itemDetail.consignee_phone }}</div>
      </div>
      <div class="width-100 fs-mid-sml fm-sh-regular darkgrey" v-if="itemDetail.address">
        <van-icon name="location-o" size="14" />{{ itemDetail.address }}
      </div>
    </div>
    <div id="shop-detail" class="width-100 br-reg bg-white flex-row align-items-center justify-content-spaceBetween padding-3">
      <div
        class="border br-reg flex-row align-items-center justify-content-center"
        :style="{ width: shopDetailWidth * 0.2 + 'px', height: shopDetailWidth * 0.2 + 'px' }"
      >
        <van-image :src="itemDetail.picture_url" width="80%" height="80%" fit="contain" />
      </div>
      <div class="width-75 flex-column align-items-center justify-content-around" :style="{ height: shopDetailWidth * 0.2 + 'px' }">
        <div class="width-100 fs-big fm-sh-bold">{{ itemDetail.name }}</div>
        <div class="width-100 fs-mid-sml fm-sh-regular black">奖品价格：{{ itemDetail.price }} 元</div>
      </div>
    </div>
    <div class="width-100 br-reg bg-white padding-3 margin-ts flex-column align-items-center justify-content-center">
      <div class="width-100 fm-sh-bold fs-mid">券码信息</div>
      <div class="flex-row align-items-center justify-content-spaceBetween width-100">
        <div class="black fs-mid-sml fm-sh-regular">{{ itemDetail.order_no }}</div>
        <div class="fs-sml fm-sh-medium darkgrey">{{ itemDetail.state_name }}<van-icon name="arrow" size="12" color="#666" /></div>
      </div>
      <div class="width-100 flex-row align-items-center justify-content-center margin-t" v-if="itemDetail.state == 3">
        <canvas id="QRCode_header" :style="{ width: shopDetailWidth * 0.6 + 'px', height: shopDetailWidth * 0.6 + 'px' }" />
      </div>
    </div>
    <div
      class="flex-column align-items-center justify-content-center width-100 bg-white br-reg padding-3 margin-ts"
      v-if="itemDetail.express_company || itemDetail.express_no"
    >
      <div class="flex-row align-items-center justify-content-spaceBetween width-100 margin-tss" v-if="itemDetail.express_company">
        <div class="black fs-mid-sml fm-sh-regular width-25">快递公司：</div>
        <div class="fs-mid-sml fm-sh-regular darkgrey width-75 textAlign-r">{{ itemDetail.express_company }}</div>
      </div>
      <div class="flex-row align-items-center justify-content-spaceBetween width-100 margin-tss" v-if="itemDetail.express_no">
        <div class="black fs-mid-sml fm-sh-regular width-25">快递单号：</div>
        <div class="fs-mid-sml fm-sh-regular darkgrey width-75 textAlign-r">{{ itemDetail.express_no }}</div>
      </div>
    </div>
    <div
      class="width-100 br-reg bg-white padding-3 margin-ts flex-column align-items-center justify-content-center"
      v-if="itemDetail.failure_time || itemDetail.shop_address || itemDetail.shop_business_hours || itemDetail.shop_rules"
    >
      <div class="width-100 fm-sh-bold fs-mid">温馨提示</div>
      <div class="flex-row align-items-center justify-content-spaceBetween width-100 margin-tss" v-if="itemDetail.failure_time">
        <div class="black fs-mid-sml fm-sh-regular width-25">有效时间：</div>
        <div class="fs-mid-sml fm-sh-regular darkgrey width-75 textAlign-r">{{ itemDetail.failure_time }}后失效</div>
      </div>
      <div class="flex-row align-items-center justify-content-spaceBetween width-100 margin-tss" v-if="itemDetail.shop_address">
        <div class="black fs-mid-sml fm-sh-regular width-25">兑换地点：</div>
        <div class="fs-mid-sml fm-sh-regular darkgrey width-75 textAlign-r">{{ itemDetail.shop_address }}</div>
      </div>
      <div class="flex-row align-items-center justify-content-spaceBetween width-100 margin-tss" v-if="itemDetail.shop_business_hours">
        <div class="black fs-mid-sml fm-sh-regular width-25">上班时间：</div>
        <div class="fs-mid-sml fm-sh-regular darkgrey width-75 textAlign-r">{{ itemDetail.shop_business_hours }}</div>
      </div>
      <div class="flex-row align-items-center justify-content-spaceBetween width-100 margin-tss" v-if="itemDetail.shop_rules" style="flex-wrap: wrap">
        <div class="black fs-mid-sml fm-sh-regular width-100">使用规则：</div>
        <div class="fs-sml fm-sh-regular darkgrey width-100 textAlign-l margin-tss">{{ itemDetail.shop_rules }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getWinningRecordInfo } from '../api/prizeManagement';
import QRCode from 'qrcode'; //引入生成二维码插件

export default {
  name: 'Home',
  data() {
    return {
      itemDetail: {
        name: '兑换商品名称1',
        price: '100',
        image: 'https://img.yzcdn.cn/vant/cat.jpeg',
        num: '114-514 2320',
        hasUsed: false,
        twoDimensionalCode: 'https://img.yzcdn.cn/vant/cat.jpeg',
        time: '2023-07-13 至 2023-07-23',
        place: '安福路666号',
        workTime: '8:30-17:00',
        description:
          '面对这个问题，我们需要拿出新水平、达到新境界，通过新举措、新发展，形成新突破，为此，我们必须重视新方法、看清新形式、理准新要求，只有这样，我们才能在新期待、新关系中，用好新本领、展现新风貌、走出新高度，新知识造就新事物、新实践获得新成果。'
      },
      shopDetailWidth: ''
    };
  },
  watch: {
    '$route.path': {
      deep: true,
      handler(v, o) {
        if (o == '/prizeClaimDetails') {
          this.$destroy();
        }
      }
    }
  },
  beforeMount() {
    getWinningRecordInfo({ id: this.$route.query.id }).then((res) => {
      if (res.code == 0) {
        this.itemDetail = res.data;
        this.$nextTick(() => {
          this.shopDetailWidth = document.getElementById('shop-detail').clientWidth;
          if (this.itemDetail.state == 3) {
            let opts = {
              errorCorrectionLevel: 'H', //容错级别
              type: 'image/png', //生成的二维码类型
              quality: 0.3, //二维码质量
              margin: 12, //二维码留白边距
              width: document.getElementById('shop-detail').clientWidth * 0.6, //宽
              height: document.getElementById('shop-detail').clientWidth * 0.6, //高
              text: this.itemDetail.order_no_url, //二维码内容
              color: {
                dark: '#333333', //前景色
                light: '#fff' //背景色
              }
            };
            let msg = document.getElementById('QRCode_header');
            QRCode.toCanvas(msg, this.itemDetail.order_no_url, opts, function (error) {
              console.log(error, 'error');
            });
          }
        });
      }
    });
  }
};
</script>

<style scoped>
.padding-3 {
  padding: 3%;
}
</style>
